<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex-grow vx-row ">
                <div style="display: inline-block" class="vx-col md:w-1/5 sm:w-auto w-full mb-2">
                    <label class="vs-input--label">{{this.$t('device.branch')}}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>
                    </v-select>
                </div>
                <div style="display: inline-block" class="vx-col md:w-1/5 sm:w-auto w-full mb-2">
                    <label class="vs-input--label">{{this.$t('device.status')}}</label>
                    <v-select class="" v-model="selectedDeviceAssignStatus" :clearable="false"
                              :options="deviceAssignStatusOptions">
                        <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>
                    </v-select>
                </div>
                <div style="display: inline-block" class="vx-col md:w-1/5 sm:w-auto w-full mb-2">
                    <label class="vs-input--label">{{this.$t('device.statusDevice')}}</label>
                    <v-select class="" v-model="selectedDeviceStatus" :clearable="false"
                              :options="deviceStatusOptions">
                        <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>
                    </v-select>
                </div>
                <div class="mr-4 vx-col mb-2 mt-2" style="display: flex;align-items: flex-end;">
                    <vs-button
                        @click="loadDevice"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="">
                        {{this.$t('device.filter')}}
                    </vs-button>
                </div>
            </div>
            <div class="flex flex-wrap items-center mt-2">
                <div class="flex-grow">
                    <vs-button
                        v-if="isPermissionAdd()"
                        @click="addDevice"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-settings">
                        {{this.$t('device.addDevice')}}
                    </vs-button>

                </div>

                <!-- ITEMS PER PAGE -->
                <Pagination
                    :itemList="deviceData"
                    :currentPage="currentPage"
                    :paginationPageSize="pageSize"
                    :gridApi="gridApi"
                />

                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                          v-model="searchQuery"
                          @input="updateSearchQuery" :placeholder="$t('button.search')"/>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="deviceData"
                         :animateRows="true"
                         :pagination="true"
                         :paginationPageSize="pageSize"
                         :localeText="{noRowsToShow: this.$t('device.noRowsToShow')} "
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                v-model="currentPage"
                @input="loadPage"/>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import moment from 'moment'
import Pagination from "../../ui-elements/Pagination.vue"
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import { isRouter } from '../../../store/permission';
import { constRouter } from '../../../store/constant';

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererActions,
        CellRendererStatus,
        Pagination
    },
    data() {
        return {
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('device.device'),
                    field: 'displayDevice',
                    width: 300
                },
                {
                    headerName: this.$t('device.serialDevice'),
                    field: 'serialNumber',
                    width: 150,
                },
                {
                    headerName: this.$t('device.statusR'),
                    field: 'status',
                    width: 150,
                    cellRenderer: 'CellRendererStatus',
                },
                {
                    headerName: this.$t('device.receive'),
                    field: 'displayEmployee',
                    width: 200,
                },
                {
                    headerName: this.$t('device.time'),
                    field: 'displayCreatedAt',
                    width: 130,
                },
                {
                    headerName: this.$t('device.actions'),
                    field: 'actions',
                    width: 200,
                    cellRenderer: 'CellRendererActions',
                },
            ],
            deviceData: [],
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            selectedDeviceStatusValue: null,
            selectedDeviceAssignStatusValue: null,
            deviceAssignStatusOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: 0, label: this.$t('equipment.unallocated')},
                {value: 1, label: this.$t('equipment.allocated')}
            ],

            deviceStatusOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: 0, label: this.$t('equipment.active')},
                {value: 1, label: this.$t('equipment.fix')},
                {value: 2, label: this.$t('equipment.crash')}
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            pageSize: 50,
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateDevice'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_DEVICE', false);
            }
        }
    },
    computed: {
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value
            }
        },
        selectedDeviceAssignStatus: {
            get() {
                return {
                    label: this.deviceAssignStatusOptions.find(x => x.value == this.selectedDeviceAssignStatusValue).label,
                    value: this.selectedDeviceAssignStatusValue
                }
            },
            set(obj) {
                this.selectedDeviceAssignStatusValue = obj.value;
            }
        },
        selectedDeviceStatus: {
            get() {
                return {
                    label: this.deviceStatusOptions.find(x => x.value == this.selectedDeviceStatusValue).label,
                    value: this.selectedDeviceStatusValue
                }
            },
            set(obj) {
                this.selectedDeviceStatusValue = obj.value;
            }
        },
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.device_add)
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || 'Chưa xác định';
        },
        addDevice() {
            this.$router.push(`/user/add-device?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },

        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },

        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },

        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            this.loadDevice()

        },
        loadDevice() {
            if (!this.selectedOrganizationBranchValue) return;
            let searchInfo = {
                deviceType: 0,
                organizationBranchId: this.selectedOrganizationBranchValue,
                status: this.selectedDeviceStatusValue,
                assignStatus: this.selectedDeviceAssignStatusValue
            }
            this.$vs.loading();
            this.$crm.post('/device/find-assigned-device', searchInfo).then((response) => {
                this.deviceData = response.data.map(item => {
                    item.displayDevice = item.type + " " + item.brand + " " + item.model
                    item.displayEmployee = item.employeeId ? item.employeeCode + " - " + item.fullName : "";
                    item.displayCreatedAt = item.assignDate ? moment(item.assignDate).format("DD/MM/YYYY") : "";
                    return item;
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
